import React from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import {IntlProvider} from './i18n/IntlContext';

import CallForPapersContainer from './CallForPapers/CallForPapersContainer';
import MyAreaContainer from "./CallForPapers/MyArea/MyAreaContainer";
import {Toaster} from "react-hot-toast";

const App = () => (
    <IntlProvider>
        <Router basename={process.env.PUBLIC_URL}>
            {/*Toast wird standardmässig oben in der Mitte angezeigt. Dieses Verhalten kann in einem Toast selbst überschrieben werden*/}
            <Toaster position={'top-center'}/>
            <Switch>
                <Route path="/myarea">
                    <MyAreaContainer/>
                </Route>

                <Route path={[
                    "/:slug/review/:submissionId/:reviewId",
                    "/:slug/review/:submissionId",
                    "/:slug/edit/:submissionId",
                    "/:slug"
                ]}>
                    <CallForPapersContainer/>
                </Route>
            </Switch>
        </Router>
    </IntlProvider>
);

export default App;
